<!-- src/components/TagModalView.vue -->

<template>
    <vue-modal 
        v-if="show" 
        @close="close()"
        class="tag-modal">
        <div slot="header">
            <h3>{{ id ? "Edit folder" : "New folder" }}</h3>
        </div>
        <div slot="body">
            <p class="my-1">Designate a name and color for your folder</p>
            <form class="my-2 space-y-6" @submit.prevent="save">
              <text-input name="tag_name" label="Name of folder" v-model="name" />
              <div class="tag-modal-colors" v-if="!isDefault">
                <status-block
                    :current-status="colorIndex"
                    :options="colors"
                    v-on:selected-status="onSelectColor"></status-block>
              </div>
              <div class="flex justify-between">
                <primary-button>Save</primary-button>
                <button
                    class="bg-white text-red-700 uppercase px-4 py-3 text-sm"
                    type="button"
                    @click.prevent="remove()"
                    v-if="id && !isDefault"
                >
                  Delete
                </button>
              </div>
            </form>
        </div>
        <div slot="footer">
        </div>
    </vue-modal>
</template>

<script>

import VueModal from '../Shared/VueModal.vue';
import VueButton from '../Shared/VueButton.vue';
import StatusBlock from '../Shared/StatusBlock.vue';
import WebServices from '../../services/WebServices';
import swal from 'sweetalert';
import TextInput from "../Form/TextInput";
import PrimaryButton from "../Form/PrimaryButton";

export default {    
    
    components: {PrimaryButton, TextInput, StatusBlock, VueModal, VueButton },
    
    props: [ "show", "type", "onSave" ],
    
    data () {
        return {
            tagServices: WebServices("Users/Me/Tags"),
            id: null,
            name: "",
            color: "",
            colorIndex: -1,
            isDefault: false,
            defaultColors: [ "#40B572", "#FFD156", "#FF5353", "#000000" ],
            colors: [
                {
                    id: 0,
                    color: "#F02323"
                },
                {
                    id: 1,
                    color: "#FFD156"
                },
                {
                    id: 2,
                    color: "#A7E766"
                },
                {
                    id: 3,
                    color: "#66C6EB"
                },
                {
                    id: 4,
                    color: "#23BAF4"
                },
                {
                    id: 5,
                    color: "#4199FF"
                },
                {
                    id: 6,
                    color: "#0067DF"
                },
                {
                    id: 7,
                    color: "#0A57B0"
                },
                {
                    id: 8,
                    color: "#BD0FE1"
                },
                {
                    id: 9,
                    color: "#7C0095"
                }
            ]
        }
    },
    
    methods: {
        
        onSelectColor (selection) {
            this.colorIndex = selection.id;
            this.color = selection.color;
        },
        
        openTag (tag) {
            this.id = tag.id;
            this.name = tag.name;
            this.color = tag.color;
            
            /// Get default index of color
            if (this.defaultColors.indexOf(tag.color) > -1) {
                this.isDefault = true;
                return;
            }
            else {
                this.isDefault = false;
                for (var i = 0; i < this.colors.length; i++) {
                    if (this.colors[i].color == tag.color) {
                        this.colorIndex = i;
                        break;
                    }
                }
            }
        },
        
        save () {
            this.id ? this.update() : this.store();
        },
        
        store () {
            
            if (this.name.length <= 0 || this.color.length <= 0) {
                swal({
                    title: "Whoops!", 
                    text: "Please make sure you have filled in all fields!", 
                    type: "warning",
                    confirmButtonColor: "#40B572"
                });
            }
            
            this.tagServices
                .store({
                    tag_type: this.type == "project" ? 1 : 2,
                    name: this.name,
                    color: this.color
                })
                .then(function(response) {
                    
                    this.reset();
                    this.$emit("on-save");
                    
                }.bind(this));
        },
        
        update () {
            
            if (this.name.length <= 0) {
                swal({
                    title: "Whoops!", 
                    text: "Please make sure you have filled in all fields!", 
                    type: "warning",
                    confirmButtonColor: "#40B572"
                });
            }
            
            this.tagServices
                .update({
                    id: this.id,
                    name: this.name,
                    color: this.color
                })
                .then(function(response) {
                    
                    this.reset();
                    this.$emit("on-save");
                    
                }.bind(this));
        },
        
        remove () {
            
            this.tagServices
                .remove(this.id)
                .then(function(response) {
                    
                    this.reset();
                    this.$emit("on-save");
                    
                }.bind(this));
        },
        
        close () {
            this.$emit("on-close");
        },
        
        reset () {
            
            this.id = null;
            this.name = "";
            this.color = "";
            this.colorIndex = -1;
            this.isDefault = false;
        }
    },
    
    watch: {
        'show': function() {
            if (this.show == false) {
                this.reset();
            }
        }
    }
}
</script>

<style>
.tag-modal .status-block {
    display: inline-block;
}

.tag-modal .status-block .status-block-label {
    display: none;
}
</style>
